<script lang="ts">
  import { Comment } from "../../../../utils/Constant/Constant";
  import Card from "../../../Core/Card.svelte";
  import {BlogSingleData} from "../../../../Data/Miscellaneous/Blog"
  import BlogComment from "../../Blog/BlogSingle/BlogComment.svelte";
</script>
<Card cardProps="comment-box">
    <div slot="contentbody">
      <h4>{Comment}</h4>
      <ul>
        {#each BlogSingleData.slice(0,3) as commentItem}
            <li>
                {#if commentItem.id !== 2}
                    <BlogComment elem={commentItem}/>
                {:else}
                    <ul>
                        <li>
                            <BlogComment elem={commentItem} />
                        </li>
                    </ul>
                {/if}
            </li>
        {/each}
      </ul>
    </div>
</Card>